import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=a55dedac&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=a55dedac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55dedac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a55dedac')) {
      api.createRecord('a55dedac', component.options)
    } else {
      api.reload('a55dedac', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=a55dedac&scoped=true&", function () {
      api.rerender('a55dedac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2487x3oQa2cym/JS/teamMember.vue"
export default component.exports